import React, { useState, useEffect } from 'react';
import Header from '../../components/ui/Header';
import Breadcrumbs from '../../components/ui/Breadcrumbs';
import QuickActionButton from '../../components/ui/QuickActionButton';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import InstallationFilters from './components/InstallationFilters';
import InstallationStats from './components/InstallationStats';
import InstallationTable from './components/InstallationTable';
import PhotoUploadModal from './components/PhotoUploadModal';
import InstallationDetailsModal from './components/InstallationDetailsModal';
import InstallationFormModal from './components/InstallationFormModal';
import ChangeKVModal from './components/ChangeKVModal';

const BrandingAndBrandingMaterialTracker = () => {
  const [installations, setInstallations] = useState([]);
  const [filteredInstallations, setFilteredInstallations] = useState([]);
  const [filters, setFilters] = useState({
    search: '',
    status: '',
    store: '',
    brand: '',
    team: '',
    fromDate: '',
    toDate: ''
  });
  const [selectedInstallation, setSelectedInstallation] = useState(null);
  const [showPhotoUpload, setShowPhotoUpload] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [showInstallationForm, setShowInstallationForm] = useState(false);
  const [showChangeKV, setShowChangeKV] = useState(false);
  const [loading, setLoading] = useState(true);

  // Enhanced mock data with KV thumbnails from Active Visual Repository
  const mockInstallations = [
    {
      id: 'INST_001',
      storeName: 'Dhaka Central Mall',
      storeCode: 'DHA',
      storeLocation: 'Gulshan-2, Dhaka',
      brandName: 'Lily Skincare',
      brandingType: 'Billboard',
      brandingId: 'BB-DHA-LIS-001',
      oldKVId: 'LIS_BB_001',
      newKVId: 'LIS_BB_002',
      status: 'planned',
      installationDate: '2025-01-15',
      createdOn: '2025-01-03T10:30:00Z',
      assignedTo: 'Store Manager',
      teamName: 'Store Team',
      teamLead: 'Ahmed Rahman',
      totalCost: 8500,
      quantity: 1,
      notes: 'KV replacement: LIS_BB_001 → LIS_BB_002',
      photos: [],
      kvThumbnails: {
        old: {
          url: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=400',
          thumbnail: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=200',
          duration: null
        },
        new: {
          url: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=400',
          thumbnail: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=200',
          duration: null
        }
      },
      auditLog: [
        {
          id: 'AUDIT_001',
          action: 'Installation Created',
          user: 'John Doe',
          timestamp: '2025-01-03T10:30:00Z',
          details: 'Installation created from KV replacement workflow',
          oldValue: null,
          newValue: 'planned'
        }
      ],
      timeline: [
        {
          title: 'Replacement Planned',
          description: 'KV replacement scheduled: LIS_BB_001 → LIS_BB_002',
          date: '2025-01-03',
          icon: 'Calendar'
        }
      ],
      replacementInfo: {
        originalKVId: 'LIS_BB_001',
        newKVId: 'LIS_BB_002',
        triggerUser: 'John Doe',
        triggerDate: '2025-01-03T10:30:00Z',
        replacementType: 'KV Archive Replacement'
      }
    },
    {
      id: 'INST_002',
      storeName: 'Chittagong Plaza',
      storeCode: 'CTG',
      storeLocation: 'Agrabad, Chittagong',
      brandName: 'Cavotin Haircare',
      brandingType: 'Gondola Branding',
      brandingId: 'GB-CTG-CAV-002',
      oldKVId: 'CAV_GB_001',
      newKVId: 'CAV_GB_002',
      status: 'installed',
      installationDate: '2025-01-10',
      createdOn: '2025-01-02T14:15:00Z',
      assignedTo: 'Regional Manager',
      teamName: 'Regional Team',
      teamLead: 'Mohammad Ali',
      totalCost: 3850,
      quantity: 1,
      notes: 'KV replacement: CAV_GB_001 → CAV_GB_002',
      photos: [{
        id: 'PHOTO_001',
        url: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=400',
        thumbnail: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=200',
        caption: 'Installation completed',
        uploadedAt: '2025-01-10T15:30:00Z'
      }],
      kvThumbnails: {
        old: {
          url: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=400',
          thumbnail: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=200',
          duration: null
        },
        new: {
          url: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400',
          thumbnail: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=200',
          duration: null
        }
      },
      auditLog: [
        {
          id: 'AUDIT_002A',
          action: 'Installation Created',
          user: 'Jane Smith',
          timestamp: '2025-01-02T14:15:00Z',
          details: 'Installation created from KV replacement workflow',
          oldValue: null,
          newValue: 'planned'
        },
        {
          id: 'AUDIT_002B',
          action: 'Status Changed',
          user: 'Mohammad Ali',
          timestamp: '2025-01-10T15:30:00Z',
          details: 'Status updated from Planned to Installed',
          oldValue: 'planned',
          newValue: 'installed'
        }
      ],
      timeline: [
        {
          title: 'Replacement Planned',
          description: 'KV replacement scheduled',
          date: '2025-01-02',
          icon: 'Calendar'
        },
        {
          title: 'Installation Completed',
          description: 'Status changed to Installed - awaiting verification',
          date: '2025-01-10',
          icon: 'CheckCircle'
        }
      ],
      replacementInfo: {
        originalKVId: 'CAV_GB_001',
        newKVId: 'CAV_GB_002',
        triggerUser: 'Jane Smith',
        triggerDate: '2025-01-02T14:15:00Z',
        replacementType: 'KV Archive Replacement'
      }
    },
    {
      id: 'INST_003',
      storeName: 'Sylhet Shopping Center',
      storeCode: 'SYL',
      storeLocation: 'Zindabazar, Sylhet',
      brandName: 'Samsung',
      brandingType: 'LED Screen',
      brandingId: 'LS-SYL-SAM-003',
      oldKVId: 'SAM_LS_001',
      newKVId: 'SAM_LS_002',
      status: 'verified',
      installationDate: '2025-01-05',
      createdOn: '2025-01-01T09:00:00Z',
      assignedTo: 'Store Manager',
      teamName: 'Store Team',
      teamLead: 'Rashida Begum',
      totalCost: 16500,
      quantity: 1,
      notes: 'KV replacement completed and verified',
      photos: [
        {
          id: 'PHOTO_002',
          url: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=400',
          thumbnail: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=200',
          caption: 'Installation completed',
          uploadedAt: '2025-01-05T16:00:00Z'
        },
        {
          id: 'PHOTO_003',
          url: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=400',
          thumbnail: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=200',
          caption: 'Verification photo',
          uploadedAt: '2025-01-08T10:15:00Z'
        }
      ],
      kvThumbnails: {
        old: {
          url: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400',
          thumbnail: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=200',
          duration: '0:30'
        },
        new: {
          url: 'https://images.unsplash.com/photo-1518709268805-4e9042af2176?w=400',
          thumbnail: 'https://images.unsplash.com/photo-1518709268805-4e9042af2176?w=200',
          duration: '0:45'
        }
      },
      auditLog: [
        {
          id: 'AUDIT_003A',
          action: 'Installation Created',
          user: 'System Auto',
          timestamp: '2025-01-01T09:00:00Z',
          details: 'Installation created from KV replacement workflow',
          oldValue: null,
          newValue: 'planned'
        },
        {
          id: 'AUDIT_003B',
          action: 'Status Changed',
          user: 'Rashida Begum',
          timestamp: '2025-01-05T16:00:00Z',
          details: 'Status updated from Planned to Installed',
          oldValue: 'planned',
          newValue: 'installed'
        },
        {
          id: 'AUDIT_003C',
          action: 'Status Changed',
          user: 'Regional Manager',
          timestamp: '2025-01-08T10:15:00Z',
          details: 'Status updated from Installed to Verified with image reference: PHOTO_003',
          oldValue: 'installed',
          newValue: 'verified',
          imageReference: 'PHOTO_003'
        }
      ],
      timeline: [
        {
          title: 'Replacement Planned',
          description: 'KV replacement scheduled for LED screen',
          date: '2025-01-01',
          icon: 'Calendar'
        },
        {
          title: 'Installation Completed',
          description: 'LED screen installation completed',
          date: '2025-01-05',
          icon: 'CheckCircle'
        },
        {
          title: 'Installation Verified',
          description: 'Regional manager verified the installation with photo',
          date: '2025-01-08',
          icon: 'Shield'
        }
      ],
      replacementInfo: {
        originalKVId: 'SAM_LS_001',
        newKVId: 'SAM_LS_002',
        triggerUser: 'System Auto',
        triggerDate: '2025-01-01T09:00:00Z',
        replacementType: 'KV Archive Replacement'
      }
    },
    {
      id: 'INST_004',
      storeName: 'Rajshahi Grand Mall',
      storeCode: 'RAJ',
      storeLocation: 'Shaheb Bazar, Rajshahi',
      brandName: 'Ponds',
      brandingType: 'Window Display',
      brandingId: 'WD-RAJ-PON-004',
      newKVId: 'PON_WD_001',
      status: 'planned',
      installationDate: '2025-01-20',
      createdOn: '2025-01-05T11:45:00Z',
      assignedTo: 'Store Manager',
      teamName: 'Store Team',
      teamLead: 'Karim Hassan',
      totalCost: 5200,
      quantity: 2,
      notes: 'Regular branding installation - no replacement',
      photos: [],
      kvThumbnails: {
        new: {
          url: 'https://images.unsplash.com/photo-1542744094-24638eff58bb?w=400',
          thumbnail: 'https://images.unsplash.com/photo-1542744094-24638eff58bb?w=200',
          duration: null
        }
      },
      auditLog: [
        {
          id: 'AUDIT_004',
          action: 'Installation Created',
          user: 'Admin User',
          timestamp: '2025-01-05T11:45:00Z',
          details: 'New installation created manually',
          oldValue: null,
          newValue: 'planned'
        }
      ],
      timeline: [
        {
          title: 'Installation Planned',
          description: 'New window display installation scheduled',
          date: '2025-01-05',
          icon: 'Calendar'
        }
      ]
    },
    {
      id: 'INST_005',
      storeName: 'Barisal City Center',
      storeCode: 'BAR',
      storeLocation: 'Band Road, Barisal',
      brandName: 'Unilever',
      brandingType: 'In-Store Static',
      brandingId: 'IS-BAR-UNI-005',
      newKVId: 'UNI_IS_001',
      status: 'installed',
      installationDate: '2025-01-12',
      createdOn: '2025-01-04T08:20:00Z',
      assignedTo: 'Regional Manager',
      teamName: 'Regional Team',
      teamLead: 'Fatima Khan',
      totalCost: 2800,
      quantity: 3,
      notes: 'In-store static branding - awaiting verification',
      photos: [],
      kvThumbnails: {
        new: {
          url: 'https://images.unsplash.com/photo-1586953208448-b95a79798f07?w=400',
          thumbnail: 'https://images.unsplash.com/photo-1586953208448-b95a79798f07?w=200',
          duration: null
        }
      },
      auditLog: [
        {
          id: 'AUDIT_005A',
          action: 'Installation Created',
          user: 'Admin User',
          timestamp: '2025-01-04T08:20:00Z',
          details: 'New installation created manually',
          oldValue: null,
          newValue: 'planned'
        },
        {
          id: 'AUDIT_005B',
          action: 'Status Changed',
          user: 'Fatima Khan',
          timestamp: '2025-01-12T14:30:00Z',
          details: 'Status updated from Planned to Installed',
          oldValue: 'planned',
          newValue: 'installed'
        }
      ],
      timeline: [
        {
          title: 'Installation Planned',
          description: 'In-store static branding scheduled',
          date: '2025-01-04',
          icon: 'Calendar'
        },
        {
          title: 'Installation Completed',
          description: 'Static branding installation completed - awaiting verification',
          date: '2025-01-12',
          icon: 'CheckCircle'
        }
      ]
    }
  ];

  useEffect(() => {
    // Simulate loading
    const loadInstallations = async () => {
      setLoading(true);
      await new Promise(resolve => setTimeout(resolve, 1000));
      setInstallations(mockInstallations);
      setLoading(false);
    };

    loadInstallations();
  }, []);

  useEffect(() => {
    // Apply filters
    let filtered = installations;

    if (filters?.search) {
      const searchTerm = filters?.search?.toLowerCase();
      filtered = filtered?.filter(installation =>
        installation?.storeName?.toLowerCase()?.includes(searchTerm) ||
        installation?.brandName?.toLowerCase()?.includes(searchTerm) ||
        installation?.brandingType?.toLowerCase()?.includes(searchTerm) ||
        installation?.teamName?.toLowerCase()?.includes(searchTerm)
      );
    }

    if (filters?.status) {
      filtered = filtered?.filter(installation => installation?.status === filters?.status);
    }

    if (filters?.store) {
      filtered = filtered?.filter(installation => 
        installation?.storeName?.toLowerCase()?.includes(filters?.store?.toLowerCase())
      );
    }

    if (filters?.brand) {
      filtered = filtered?.filter(installation => 
        installation?.brandName?.toLowerCase()?.includes(filters?.brand?.toLowerCase())
      );
    }

    if (filters?.team) {
      filtered = filtered?.filter(installation => 
        installation?.teamName?.toLowerCase()?.includes(filters?.team?.toLowerCase())
      );
    }

    if (filters?.fromDate) {
      filtered = filtered?.filter(installation => 
        new Date(installation.installationDate) >= new Date(filters.fromDate)
      );
    }

    if (filters?.toDate) {
      filtered = filtered?.filter(installation => 
        new Date(installation.installationDate) <= new Date(filters.toDate)
      );
    }

    setFilteredInstallations(filtered);
  }, [filters, installations]);

  // Enhanced status update handler with comprehensive audit logging
  const handleStatusUpdate = (installationIds, newStatus, options = {}) => {
    setInstallations(prev =>
      prev?.map(installation => {
        if (installationIds?.includes(installation?.id)) {
          const updatedInstallation = { ...installation, status: newStatus };
          
          // Create comprehensive audit log entry
          const auditEntry = {
            id: `AUDIT_${Date.now()}_${Math.random()?.toString(36)?.substr(2, 9)}`,
            action: options?.isUndo ? 'Status Changed (Undo)' : 'Status Changed',
            user: options?.user || 'Current User',
            timestamp: new Date()?.toISOString(),
            details: options?.isUndo 
              ? `Status reverted from ${installation?.status} back to ${newStatus} (Undo action)`
              : `Status updated from ${installation?.status} to ${newStatus}`,
            oldValue: installation?.status,
            newValue: newStatus,
            imageReference: options?.imageReference || null,
            isUndo: options?.isUndo || false
          };
          
          updatedInstallation.auditLog = [...(installation?.auditLog || []), auditEntry];
          
          // Update timeline with appropriate entry
          const timelineEntry = {
            title: options?.isUndo 
              ? `Status Reverted (Undo)` 
              : newStatus === 'installed' ?'Installation Completed' 
                : newStatus === 'verified' ?'Installation Verified' :'Status Updated',
            description: options?.isUndo
              ? `Status reverted back to ${newStatus?.charAt(0)?.toUpperCase() + newStatus?.slice(1)} via undo action`
              : newStatus === 'installed' ?'Status changed to Installed - awaiting verification' 
                : newStatus === 'verified' ?'Installation verified with photo evidence' 
                  : `Status changed to ${newStatus}`,
            date: new Date()?.toISOString()?.split('T')?.[0],
            icon: options?.isUndo 
              ? 'Undo2' 
              : newStatus === 'installed' ?'CheckCircle' 
                : newStatus === 'verified' ?'Shield' :'Clock'
          };
          
          updatedInstallation.timeline = [...(installation?.timeline || []), timelineEntry];
          
          return updatedInstallation;
        }
        return installation;
      })
    );
  };

  // New handler for status transitions with validation
  const handleStatusTransition = (installation, newStatus) => {
    // Validation for Installed → Verified transition
    if (installation?.status === 'installed' && newStatus === 'verified') {
      if (!installation?.photos || installation?.photos?.length === 0) {
        alert('At least one image must be uploaded before marking as verified.');
        return;
      }
    }
    
    // Update status with audit logging
    handleStatusUpdate([installation?.id], newStatus, {
      user: 'Current User', // In real app, get from auth context
      imageReference: installation?.photos?.[installation?.photos?.length - 1]?.id
    });
  };

  // NEW: Handle KV change with status reset rules
  const handleKVChange = (installationId, oldKVId, newKVId, newThumbnail) => {
    setInstallations(prev =>
      prev?.map(installation => {
        if (installation?.id === installationId) {
          const updatedInstallation = { ...installation };
          
          // Update KV information
          updatedInstallation.oldKVId = installation?.newKVId; // Current new becomes old
          updatedInstallation.newKVId = newKVId;
          
          // Update thumbnails
          if (installation?.kvThumbnails?.new) {
            updatedInstallation.kvThumbnails = {
              old: installation?.kvThumbnails?.new, // Current new becomes old
              new: newThumbnail
            };
          } else {
            updatedInstallation.kvThumbnails = {
              new: newThumbnail
            };
          }
          
          // Apply status reset rules
          const currentStatus = installation?.status?.toLowerCase();
          if (currentStatus === 'verified') {
            updatedInstallation.status = 'planned';
          } else if (currentStatus === 'installed') {
            // Stays installed but requires new image before verify
            updatedInstallation.requiresNewImage = true;
          }
          
          // Create audit log entry
          const auditEntry = {
            id: `AUDIT_${Date.now()}_${Math.random()?.toString(36)?.substr(2, 9)}`,
            action: 'KV Changed',
            user: 'Current User',
            timestamp: new Date()?.toISOString(),
            details: `KV changed from ${installation?.newKVId || 'N/A'} to ${newKVId}${currentStatus === 'verified' ? '. Status reset to Planned.' : currentStatus === 'installed' ? '. New image required before verification.' : ''}`,
            oldValue: installation?.newKVId || 'N/A',
            newValue: newKVId
          };
          
          updatedInstallation.auditLog = [...(installation?.auditLog || []), auditEntry];
          
          // Update timeline
          const timelineEntry = {
            title: 'KV Changed',
            description: `KV updated from ${installation?.newKVId || 'N/A'} to ${newKVId}`,
            date: new Date()?.toISOString()?.split('T')?.[0],
            icon: 'RefreshCw'
          };
          
          updatedInstallation.timeline = [...(installation?.timeline || []), timelineEntry];
          
          return updatedInstallation;
        }
        return installation;
      })
    );
  };

  const handleFiltersChange = (newFilters) => {
    setFilters(newFilters);
  };

  const handleClearFilters = () => {
    setFilters({
      search: '',
      status: '',
      store: '',
      brand: '',
      team: '',
      fromDate: '',
      toDate: ''
    });
  };

  const handleViewDetails = (installation) => {
    setSelectedInstallation(installation);
    setShowDetails(true);
  };

  const handlePhotoUpload = (installation) => {
    setSelectedInstallation(installation);
    setShowPhotoUpload(true);
  };

  const handleChangeKV = (installation) => {
    setSelectedInstallation(installation);
    setShowChangeKV(true);
  };

  const handlePhotoUploadComplete = (newPhotos) => {
    if (selectedInstallation) {
      setInstallations(prev =>
        prev?.map(installation =>
          installation?.id === selectedInstallation?.id
            ? { 
                ...installation, 
                photos: [...(installation?.photos || []), ...newPhotos],
                requiresNewImage: false, // Clear the image requirement flag
                auditLog: [
                  ...(installation?.auditLog || []),
                  {
                    id: `AUDIT_${Date.now()}_${Math.random()?.toString(36)?.substr(2, 9)}`,
                    action: 'Photos Uploaded',
                    user: 'Current User',
                    timestamp: new Date()?.toISOString(),
                    details: `${newPhotos?.length} photo(s) uploaded`,
                    oldValue: null,
                    newValue: `${newPhotos?.length} photos`
                  }
                ]
              }
            : installation
        )
      );
    }
  };

  // NEW: Handle new installation creation
  const handleNewInstallation = (installationData) => {
    setInstallations(prev => [installationData, ...prev]);
    
    // Show success message
    alert(`Installation "${installationData?.id}" has been created successfully! Status: ${installationData?.status?.toUpperCase()}`);
  };

  // Auto-creation function for KV replacements (to be called from KV management)
  const createInstallationFromKVReplacement = (replacementData) => {
    const newInstallation = {
      id: `INST_${Date.now()}`,
      storeName: replacementData?.storeName,
      storeCode: replacementData?.storeCode,
      storeLocation: replacementData?.storeLocation || 'Location TBD',
      brandName: replacementData?.brandName,
      brandingType: replacementData?.brandingMedium,
      brandingId: replacementData?.brandingId,
      oldKVId: replacementData?.oldKVId,
      newKVId: replacementData?.newKVId,
      status: 'planned', // Default status
      installationDate: replacementData?.scheduledDate || new Date(Date.now() + 7 * 24 * 60 * 60 * 1000)?.toISOString()?.split('T')?.[0], // Default to 7 days from now
      createdOn: new Date()?.toISOString(),
      assignedTo: replacementData?.assignedTo || 'Store Manager',
      teamName: replacementData?.teamName || 'Store Team',
      teamLead: replacementData?.teamLead || 'Store Manager',
      totalCost: replacementData?.estimatedCost || 0,
      quantity: 1,
      notes: `KV replacement: ${replacementData?.oldKVId} → ${replacementData?.newKVId}`,
      photos: [],
      auditLog: [
        {
          id: `AUDIT_${Date.now()}_AUTO`,
          action: 'Installation Created',
          user: replacementData?.triggerUser || 'System Auto',
          timestamp: new Date()?.toISOString(),
          details: 'Installation automatically created from KV replacement workflow',
          oldValue: null,
          newValue: 'planned'
        }
      ],
      timeline: [
        {
          title: 'Replacement Planned',
          description: `KV replacement scheduled: ${replacementData?.oldKVId} → ${replacementData?.newKVId}`,
          date: new Date()?.toISOString()?.split('T')?.[0],
          icon: 'Calendar'
        }
      ],
      replacementInfo: {
        originalKVId: replacementData?.oldKVId,
        newKVId: replacementData?.newKVId,
        triggerUser: replacementData?.triggerUser,
        triggerDate: new Date()?.toISOString(),
        replacementType: 'KV Archive Replacement'
      }
    };
    
    setInstallations(prev => [newInstallation, ...prev]);
    return newInstallation?.id;
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-background">
        <Header />
        <div className="flex items-center justify-center h-96">
          <div className="flex items-center gap-3">
            <div className="w-6 h-6 border-2 border-primary border-t-transparent rounded-full animate-spin"></div>
            <span className="text-muted-foreground">Loading branding materials...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main className="max-w-7xl mx-auto px-4 py-6">
        <Breadcrumbs />

        {/* Page Header */}
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-6">
          <div>
            <h1 className="text-2xl font-bold text-foreground">Branding and Branding Material Tracker</h1>
            <p className="text-muted-foreground mt-1">
              Streamlined 3-step workflow: Planned → Installed → Verified
            </p>
          </div>
          <div className="flex items-center gap-3">
            <Button
              variant="outline"
              onClick={() => window.print()}
            >
              <Icon name="Printer" size={16} />
              Export Report
            </Button>
            <Button
              variant="default"
              onClick={() => setShowInstallationForm(true)}
            >
              <Icon name="Plus" size={16} />
              New Installation
            </Button>
          </div>
        </div>

        <InstallationStats installations={filteredInstallations} />

        <InstallationFilters
          filters={filters}
          onFiltersChange={handleFiltersChange}
          onClearFilters={handleClearFilters}
        />

        <InstallationTable
          installations={filteredInstallations}
          onStatusUpdate={handleStatusUpdate}
          onStatusTransition={handleStatusTransition}
          onViewDetails={handleViewDetails}
          onPhotoUpload={handlePhotoUpload}
          onChangeKV={handleChangeKV}
        />

        <InstallationFormModal
          isOpen={showInstallationForm}
          onClose={() => setShowInstallationForm(false)}
          onSubmit={handleNewInstallation}
        />

        <PhotoUploadModal
          isOpen={showPhotoUpload}
          onClose={() => {
            setShowPhotoUpload(false);
            setSelectedInstallation(null);
          }}
          installation={selectedInstallation}
          onUpload={handlePhotoUploadComplete}
        />

        <InstallationDetailsModal
          isOpen={showDetails}
          onClose={() => {
            setShowDetails(false);
            setSelectedInstallation(null);
          }}
          installation={selectedInstallation}
          onStatusUpdate={handleStatusUpdate}
          onStatusTransition={handleStatusTransition}
          onPhotoUpload={handlePhotoUpload}
          onChangeKV={handleChangeKV}
        />

        <ChangeKVModal
          isOpen={showChangeKV}
          onClose={() => {
            setShowChangeKV(false);
            setSelectedInstallation(null);
          }}
          installation={selectedInstallation}
          onConfirm={handleKVChange}
        />
      </main>

      <QuickActionButton />
    </div>
  );
};

export default BrandingAndBrandingMaterialTracker;